import * as React from "react"
import { Appearance, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { Actionsheet, ActionsheetProps } from "../actionsheet/actionsheet"
import { useDisclose, View } from "native-base"
import { FC, PropsWithChildren, useCallback, useEffect } from "react"
import { LazyRender } from "../lazy-render/lazy-render"
import { Text } from "../text/text"
import { TextProps } from "../text/text.props"

interface ActionsheetComponentProps {
  colorScheme?: "light"|"dark",
  titleText: string, titleTextProps?: TextProps,
  descriptionText: string, descriptionTextProps?: TextProps,
}

export interface AlertActionsheetProps extends PropsWithChildren<any> {
  isOpen?: boolean,
  onOpen?: () => void,
  onClose?: () => void,
  titleText?: string,
  descriptionText?: string,

  actionsheetProps?: ActionsheetProps,
  actionsheetComponentProps?: Omit<ActionsheetComponentProps, "titleText"|"descriptionText">

  colorScheme?: "light" | "dark",
  actionSheetColorScheme?: "light" | "dark"
}

const ACTIONSHEET: ViewStyle = {
  minHeight: 132,
  height: undefined
}

const ActionsheetComponent: FC<ActionsheetComponentProps> = function ActionsheetComponent(props) {
  const {
    colorScheme = Appearance.getColorScheme(),
    titleText, titleTextProps = {},
    descriptionText, descriptionTextProps = {}
  } = props;

  return <View py="16px" px="16px">
    <Text text={titleText} preset="display3" mb="8px" colorScheme={colorScheme} {...titleTextProps} />
    <View minHeight="60px">
      <Text text={descriptionText} preset="body2" colorScheme={colorScheme} {...descriptionTextProps} />
    </View>
  </View>;
}

/**
 * Describe your component here
 */
export const AlertActionsheet: FC<AlertActionsheetProps> = observer(function AlertActionsheet(props) {
  const {
    isOpen: isOpenProp,
    onOpen: onOpenProp, onClose: onCloseProp,
    titleText = "Title", descriptionText = "Description",
    actionsheetProps,
    actionsheetComponentProps,
    colorScheme = Appearance.getColorScheme(),
    actionSheetColorScheme = colorScheme,
    clearable,
    children
  } = props

  const { isOpen, onOpen, onClose: onCloseDisclose } = useDisclose()

  useEffect(() => {
    if (isOpenProp) onOpen()
    else if (isOpenProp === false) onCloseDisclose()
  }, [isOpenProp, onCloseDisclose, onOpen])

  useEffect(() => {
    if (isOpen) onOpenProp && onOpenProp()
  }, [isOpen, onOpenProp])

  const onClose: () => void = useCallback(() => {
    onCloseProp && onCloseProp()
    onCloseDisclose()
  }, [onCloseDisclose, onCloseProp])

  return (
    <>
      <Actionsheet
        colorScheme={actionSheetColorScheme}
        isOpen={isOpen}
        onClose={onClose}
        clearable={clearable}
        actionsheetStyle={ACTIONSHEET}
        {...actionsheetProps}
      >
        {children || <LazyRender>
          <ActionsheetComponent
            colorScheme={colorScheme}
            titleText={titleText}
            descriptionText={descriptionText}
            {...actionsheetComponentProps}
          />
        </LazyRender>}
      </Actionsheet>
    </>
  )
})
